import React, { useMemo } from 'react';
import styles from './UIGameSpectators.module.scss';
import { Avatar } from '../../common/Avatar/Avatar.tsx';
import { useTranslation, Tooltip } from '@colonist/ui';
import IconEye from '@static/images/icon_eye.svg';
import { useUIGameSpectatorsContext } from './UIGameSpectatorsContext.tsx';
import { PlayerColor } from '@colonist/game-states';
const MAX_TOOLTIP_NAMES = 10;
export const UIGameSpectators = ({ maxAvatarsVisible = 3 })=>{
    const { t } = useTranslation();
    const { spectators } = useUIGameSpectatorsContext();
    const visibleSpectators = spectators.slice(0, maxAvatarsVisible);
    const extraCount = spectators.length - maxAvatarsVisible;
    const hiddenSpectators = spectators.slice(maxAvatarsVisible);
    const tooltipUsernamesText = useMemo(()=>hiddenSpectators.slice(0, MAX_TOOLTIP_NAMES).map((s)=>s.username).join(', '), [
        hiddenSpectators
    ]);
    if (spectators.length === 0) return null;
    const tooltipOverflowCount = hiddenSpectators.length - MAX_TOOLTIP_NAMES;
    const isSpectatorListOverflowing = hiddenSpectators.length > MAX_TOOLTIP_NAMES;
    const tooltipOverflowText = isSpectatorListOverflowing ? t('strings:game.tooltips.andOthers', {
        count: tooltipOverflowCount
    }) : '';
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.spectatorsContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.avatarsContainer
    }, visibleSpectators.map((spectator, idx)=>/*#__PURE__*/ React.createElement(Tooltip, {
            key: spectator.username + idx,
            title: spectator.username
        }, /*#__PURE__*/ React.createElement(Avatar, {
            color: PlayerColor.White,
            className: styles.avatar,
            image: spectator.avatar,
            profilePictureUrl: spectator.profilePictureUrl
        }))), extraCount > 0 && /*#__PURE__*/ React.createElement(Tooltip, {
        menuClassName: styles.spectatorsTooltipMenu,
        centerText: true,
        content: /*#__PURE__*/ React.createElement(React.Fragment, null, tooltipUsernamesText, tooltipOverflowText)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.extraCount
    }, "+", extraCount))), /*#__PURE__*/ React.createElement("div", {
        className: styles.eyeIcon
    }, /*#__PURE__*/ React.createElement("img", {
        src: IconEye
    })));
};
